// Phone helpers: enforce country code + digits only on lead/enquiry forms.

// Keep only a single leading "+" and digits. Strips letters and other chars.
export const sanitizePhone = (value = '') => {
  let v = String(value).replace(/[^\d+]/g, '');
  // allow only one leading '+'
  v = v.replace(/\+(?=.*\+)/g, '');
  if (v.indexOf('+') > 0) v = '+' + v.replace(/\+/g, '');
  return v;
};

// Must start with a country code ("+") followed by 8–15 digits.
export const isValidPhone = (value = '') => /^\+\d{8,15}$/.test(sanitizePhone(value));

export const PHONE_ERROR = 'Please enter a valid phone number with country code (e.g. +971...). Numbers only.';
